import { css } from '@emotion/react'
import { Typography, useMediaQuery } from '@mui/material'
import { useTranslation } from 'next-i18next'
import ClipboardClock from 'assets/icons/nucleo/18px_clipboard-clock.svg'
import { Button, ButtonVariant } from 'components/common/Button'
import { NewFlexContainer } from 'components/common/common.style'
import { unifiedColors } from 'styles/colors'
import { media } from 'styles/responsive'
import { styled } from 'styles/styled'
import { themeUtils } from 'styles/theme'

interface WaitingListFooterProps {
  openWaitingListModale: () => void
}

const WaitingListFooterContainer = styled(NewFlexContainer)`
  width: 100%;
  align-items: flex-end;
  background-color: ${unifiedColors.surface.red};
  margin-top: -25px;
  border-end-end-radius: 20px;
  border-end-start-radius: 20px;
  margin-bottom: 11px;
  padding-top: 25px;
`

const WaitingListFooterContent = styled(NewFlexContainer, {
  shouldForwardProp: (prop) => prop !== 'alignItems'
})`
  padding: 20px;
  gap: 5px;
  flex-grow: 1;
  ${media.maxWidth.sm} {
    padding: 10px 16px;
    align-items: center;
  }
`

export const WaitingListFooter = ({
  openWaitingListModale
}: WaitingListFooterProps) => {
  const { t } = useTranslation('checkout')
  const isMobile = useMediaQuery(themeUtils.maxWidth.sm)

  return (
    <WaitingListFooterContainer>
      <NewFlexContainer
        alignItems="center"
        width="100%"
        css={css`
          ${media.maxWidth.sm} {
            flex-direction: column;
          }
        `}
      >
        <WaitingListFooterContent alignItems="center">
          <ClipboardClock
            css={css`
              min-width: 22px;
              transform: scale(1.2);
              path {
                stroke: ${unifiedColors.label.default};
              }
            `}
          />
          <Typography variant="body2" color={unifiedColors.label.default}>
            {t('race.waitingList.register')}
          </Typography>
        </WaitingListFooterContent>
        <NewFlexContainer
          padding="0 20px 0 0"
          css={css`
            ${media.maxWidth.sm} {
              width: 100%;
              flex-direction: column;
              padding: 0 16px 10px;
            }
          `}
        >
          <Button
            variant={ButtonVariant.Default}
            label={t('race.waitingList.beAlerted')}
            onClick={openWaitingListModale}
            fullWidth={isMobile}
            css={css`
              ${media.minWidth.sm} {
                min-width: 125px;
              }
            `}
          />
        </NewFlexContainer>
      </NewFlexContainer>
    </WaitingListFooterContainer>
  )
}
